export const GRAY_800 = '#1D2939';
export const GRAY_500 = '#667085';
export const GRAY_900 = '#101828';
export const GRAY_700 = '#344054';
export const GRAY_300 = '#D0D5DD';
export const GRAY_200 = '#E4E7EC';
// export const GRAY_50 = '#F9FAFB';
export const GRAY_50 = '#FCFCFD';

// Status color scale (Untitled-UI numeric-scale convention)
export const SUCCESS_700 = '#067647'; // green — text on light (valid / success)
export const SUCCESS_400 = '#49d130'; // green — bright, text on dark
export const ERROR_600 = '#D92D20';   // red — text on light (invalid / error)
export const ERROR_400 = '#FF3131';   // red — bright, text on dark
export const WARNING_500 = '#FF7518'; // orange
export const WARNING_300 = '#FFDA03'; // amber / yellow
export const BASE_WHITE = '#FFFFFF';

export const COLOR_CODE = [
  {
    bgColor: '#F9F5FF',
    color: '#6941C6',
  },
  {
    bgColor: '#EFF8FF',
    color: '#175CD3',
  },
  {
    bgColor: '#EEF4FF',
    color: '#3538CD',
  },
  {
    bgColor: '#FDF2FA',
    color: '#C11574',
  },
  {
    bgColor: '#ECFDF3',
    color: '#027A48',
  },
  {
    bgColor: '#F8F9FC',
    color: '#363F72',
  },
  {
    bgColor: '#F0F9FF',
    color: '#026AA2',
  },
  {
    bgColor: '#F4F3FF',
    color: '#5925DC',
  },
  {
    bgColor: '#FFF1F3',
    color: '#C01048',
  },
  {
    bgColor: '#FFF6ED',
    color: '#C4320A',
  },
  {
    bgColor: '#F2F4F7',
    color: '#344054',
  },
];

export const USER_STATUS = {
  false: '#D0D5DD',
  true: '#12B76A',
};

export const ROBOT_STATUS_COLORS = {
  GREEN: '#12B76A',
  GOLD: '#FBC348',
  RED: '#FF5C5C',
  GREY: '#D0D5DD',
  BLACK: '#000000',
};

export const ROBOT_STATUS_DASHBOARD_TEXT_COLORS = {
  GREEN: SUCCESS_400,
  RED: ERROR_400,
  WHITE: BASE_WHITE,
  ORANGE: WARNING_500,
  YELLOW: WARNING_300,
};
